import React, { useState, useEffect } from "react";
import { useParams, useHistory } from "react-router";
import styles from "../Assets/css/jobposting.module.css";
import FactorySVG from "../Assets/img/JobPostings/Vector1.png";
import LocationImg from "../Assets/img/JobPostings/Vector.png";
import DateAdded from "../Assets/img/JobPostings/Vector2.png";
import Payment from "../Assets/img/JobPostings/Vector3.png";
import DueDate from "../Assets/img/JobPostings/Vector4.png";
import CompanyLogo from "../Assets/img/JobPostings/cantilever-logo-final-black.png";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import useMedia from "../componentsofcourse/useMedia";
export default function JobPostingData(props) {
	const matches = useMedia("(min-width : 768px )");
	const [postingData, setPostingData] = useState({
		dateAdded: "10",
		dueDate: "10",
		description: "",
		skillsRequired: "",
	});

	const [dataFormat, setDataFormat] = useState({
		dateAdded: [],
		dueDate: [],
		description: [],
		skillsRequired: [],
	});

	const { id } = useParams();
	const history = useHistory();

	useEffect(() => {
		let month = {
			0: "Jan'",
			1: "Feb'",
			2: "March",
			3: "April",
			4: "May",
			5: "June",
			6: "July",
			7: "Aug'",
			8: "Sept'",
			9: "Oct'",
			10: "Nov'",
			11: "Dec'",
		};
		let dateAdded = dateSetFunc(postingData.dateAdded).split("-");
		let dueDate = dateSetFunc(postingData.dueDate).split("-");
		let description = postingData?.description.split("\n");
		let skillsRequired = postingData?.skillsRequired.split("\n");
		if (dateAdded.length > 1 && dueDate.length > 1) {
			dateAdded[1] = month[dateAdded[1]];
			dateAdded[2] = `${dateAdded[2].split("")[2]}${
				dateAdded[2].split("")[3]
			}`;
			dueDate[1] = month[dueDate[1]];
			dueDate[2] = `${dueDate[2].split("")[2]}${dueDate[2].split("")[3]}`;
			let data = {
				dateAdded,
				dueDate,
				description,
				skillsRequired,
			};
			setDataFormat(data);
		}
	}, [postingData]);

	useEffect(() => {
		console.log(dataFormat);
	}, [dataFormat]);

	useEffect(() => {
		const API_ENDPOINT = "https://api.cantileverlabs.com/";
		fetch(`${API_ENDPOINT}getJobPosting/${id}`)
			.then((res) => res.json())
			.then((data) => {
				console.log(data);
				setPostingData(data);
			})
			.catch((err) => {
				history.push("/");
			});
	}, [id]);

	function dateSetFunc(msecString) {
		let time_string = new Date(parseInt(msecString));
		return `${time_string.getDate()}-${time_string.getMonth()}-${time_string.getFullYear()}`;
	}

	return (
		<>
			{matches == true ? (
				<>
					<Navbar />
					<div
						class="container justify-content-center"
						style={styles.body}
					>
						{/* <div class="my-5">
                    <p class={`${styles.job_board_hd_J}`}>{postingData.positionName}</p>
                    <div class="row mb-5">
                        <div class="col-xl-8 col-lg-8 col-md-9 col-sm-9 col-9">
                            <div class="row mx-2">
                                <div class="d-flex mr-4">
                                    <img class={`${styles.job_board_logo1_J} mr-2`} src={FactorySVG} alt=""/>
                                    <p>{postingData.companyName}</p>
                                </div>
                                {postingData.Location && <div class="d-flex">
                                    <img class={`${styles.job_board_logo2_J} mr-2`} src={LocationImg} alt=""/>
                                    <p>{postingData.Location}</p>
                                </div>}
                            </div>
                        </div>
                        <div class={`col-xl-3 col-lg-3 col-md-3 col-sm-2 col-2 ${styles.job_board_bg_J}`}>
                            <button class={`btn ${styles.job_board_btn_J} p-xl-3 p-sm-2 `}>Apply Now</button>
                        </div>
                    </div>
                </div> */}
						<div
							className="container row my-5 "
							style={{ paddingLeft: "0px" }}
						>
							<div
								className="col d-flex justify-content-between"
								style={{ paddingLeft: "0px" }}
							>
								<div className="heading">
									<div className={styles.job_board_hd_J}>
										{postingData.positionName}
									</div>
									<br />
									<p>
										{" "}
										<img
											style={{
												width: "23px",
												height: "18px",
												marginBottom: "0.4em",
												marginLeft: "0.2rem",
											}}
											className={styles.job_board_logo1_J}
											src={FactorySVG}
										/>{" "}
										<span style={{ color: "#636363" }}>
											{" "}
											{postingData.companyName}{" "}
										</span>
										{postingData.Location && (
											<>
												<img
													src={LocationImg}
													alt=""
													style={{
														marginLeft: "2rem",
														width: "16px",
														marginBottom: "0.4rem",
													}}
												/>{" "}
											</>
										)}{" "}
										<span style={{ color: "#636363" }}>
											{" "}
											{postingData.Location}{" "}
										</span>
									</p>
								</div>

								<div style={{ float: "right" }}>
									<button
										className={
											"btn my-4 p-xl-3 p-sm-2 " +
											styles.job_board_btn_J
										}
										onClick={() => {
											window.location.replace(
												`${postingData.links}`
											);
										}}
									>
										Apply now
									</button>
								</div>
							</div>
						</div>

						<div
							className={`container  ${styles.job_board_J} my-5 `}
						>
							<div className="row  my-4">
								<div className="col-xl-8 col-lg-8 col-md-8 col-sm-6 col-6">
									<div className="row">
										<div className=" col-xl-3 col-lg-3 col-md-3 col-sm-8 col-10 ml-0 my-sm-1">
											<div className="d-flex">
												<img
													className={`mr-2 ${styles.job_board_logo3_J}`}
													src={DateAdded}
													alt=""
												/>
												<p
													className={`${styles.job_board_p_J}`}
												>
													POSTED DATE
												</p>
											</div>
											<p
												class={`${styles.job_board_p_dark_J}`}
											>
												{dataFormat.dateAdded[0]}th{" "}
												{dataFormat.dateAdded[1]}{" "}
												{dataFormat.dateAdded[2]}
											</p>
										</div>
										<div class=" col-xl-3 col-lg-3 col-md-3 col-sm-8 col-10 ml-0 my-sm-1">
											<div class="d-flex">
												<img
													class={`mr-2 ${styles.job_board_logo4_J}`}
													src={Payment}
													alt=""
												/>
												<p
													class={`${styles.job_board_p_J}`}
												>
													PAYMENT
												</p>
											</div>
											<p
												class={`${styles.job_board_p_dark_J}`}
											>
												{postingData.payRange}
											</p>
										</div>
										<div class=" col-xl-3 col-lg-3 col-md-3 col-sm-8 col-10 ml-0 my-sm-1">
											<div class="d-flex">
												<img
													class={`mr-2 ${styles.job_board_logo5_J}`}
													src={DueDate}
													alt=""
												/>
												<p
													class={`${styles.job_board_p_J}`}
												>
													APPLY BY
												</p>
											</div>
											<p
												class={`${styles.job_board_p_dark_J}`}
											>
												{dataFormat.dueDate[0]}th{" "}
												{dataFormat.dueDate[1]}{" "}
												{dataFormat.dueDate[2]}
											</p>
										</div>
									</div>
								</div>
								{postingData.companyLogo && (
									<div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-6">
										<img
											class={`${styles.job_board_img_J}`}
											src={postingData.companyLogo}
											alt=""
										/>
									</div>
								)}
							</div>

							<div class="my-5">
								<h5 class={`${styles.job_board_hd2_J}`}>
									About the company
								</h5>
								<div class="mx-3">
									<p class={`${styles.job_board_list_J}`}>
										{postingData.aboutCompany}
									</p>
								</div>
							</div>
							<div class="my-5">
								<h5 class={`${styles.job_board_hd2_J}`}>
									Job description
								</h5>
								<div>
									<ol>
										{dataFormat.description.map((val) => {
											return (
												<li
													style={{ lineHeight: 0.5 }}
													class={`${styles.job_board_list_J}`}
												>
													{val}
												</li>
											);
										})}
									</ol>
								</div>
							</div>

							<div class="my-5">
								<h5 class={`${styles.job_board_hd2_J}`}>
									Skills
								</h5>
								<div>
									<ol>
										{dataFormat.skillsRequired.map(
											(skill) => (
												<li
													style={{ lineHeight: 0.5 }}
													key={skill}
													class={`${styles.job_board_list_J}`}
												>
													{skill}
												</li>
											)
										)}
									</ol>
								</div>
							</div>
						</div>
					</div>
					<Footer />
				</>
			) : (
				<div>
					<div className="container-fluid p-4">
						<h1>Internship details</h1>
					</div>

					<div className="container-fluid">
						<div className="row">
							<p
								style={{
									fontWeight: "600",
									fontSize: "1.3rem",
								}}
							>
								{postingData.positionName}
							</p>

							<br />
							<span className="text-muted">
								{postingData.companyName}
							</span>
							<span className="text-muted">
								{postingData.Location}
							</span>

							<img src="" alt="" />
						</div>
					</div>
					<div
						className="m-3"
						style={{
							borderRadius: "4px",
							border: "2px solid #B7B7B7",
						}}
					>
						<div className="row pt-3">
							<div
								className="col-4 p-0 "
								style={{ marginLeft: "4%" }}
							>
								<img src={DateAdded} alt="" />
								<p
									className="text-muted"
									style={{
										display: "inline",
										fontSize: "0.9rem",
									}}
								>
									{" "}
									6 months
								</p>
							</div>

							<div className="col-5 p-0">
								<img src={DueDate} alt="" />
								<p
									className="text-muted"
									style={{
										display: "inline",
										fontSize: "0.8rem",
										marginLeft: "2px",
									}}
								>
									{dataFormat.dueDate[0]}th{" "}
									{dataFormat.dueDate[1]}{" "}
									{dataFormat.dueDate[2]}
								</p>
							</div>

							<div className="col">
								<img src={LocationImg} alt="" />
							</div>
						</div>
						<div className="row">
							<div className="col pb-5">
								<img src={Payment} alt="" />
								<p
									style={{
										display: "inline",
										fontSize: "0.8rem",
										marginLeft: "3px",
									}}
									className="text-muted"
								>
									{postingData.payRange}
								</p>
							</div>
						</div>
						<div className="row">
							<p style={{ fontWeight: "600" }}>
								About the company
							</p>

							<p>{postingData.aboutCompany}</p>
						</div>

						<div className="row">
							<p style={{ fontWeight: "600" }}>Job description</p>

							{/* <p> Lorem ipsum dolor sit, ametasdfsadf consectetur adipisicing elit. temporibus, numquam quas autem debitis, beatae sed accusamus!</p> */}
							<div>
								<ol style={{ paddingLeft: "0px" }}>
									{dataFormat.description.map((val) => {
										return (
											<p
												class={`${styles.job_board_list_J}`}
											>
												{val}
											</p>
										);
									})}
								</ol>
							</div>
						</div>
						<div className="row">
							<p style={{ fontWeight: "600" }}>Skills</p>

							<ol>
								{dataFormat.skillsRequired.map((skill) => (
									<p key={skill}>{skill}</p>
								))}
							</ol>
						</div>
					</div>

					<div className="container m-2">
						<button
							onClick={() => {
								window.location.replace(`${postingData.links}`);
							}}
							type="button"
							style={{ width: "95%", borderRadius: "6px" }}
							class="btn btn-primary btn-lg btn-block"
						>
							Apply
						</button>
					</div>
				</div>
			)}
			<br />
		</>
	);
}
